<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameConfirmResult.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameConfirmResult.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end">
          <a-date-picker
            v-model="dateFilter"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            @change="onDateChange"
          />
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.game_setting_name }}</td>
          <td>{{ record.draw_time }}</td>
          <td>{{ record.input_counter }}</td>
          <td>{{ record.result_number }}</td>
          <td>
            <span class="badge badge-success" v-if="record.is_released">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="ts-space-x-3 ts-whitespace-no-wrap ts-text-right">
            <a
              v-if="record.input_counter >= 2 && record.is_released != true"
              @click.prevent="confirmResult(record)"
              href="#"
              v-tooltip="$t('gameConfirmResult.release')"
            >
              <i class="far fa-check-square"></i>
            </a>
            <a
              v-if="record.result_id"
              href="#"
              v-tooltip="$t('gameConfirmResult.link')"
              @click.prevent="addLink(record)"
            >
              <i class="fas fa-link"></i>
            </a>
          </td>
        </template>
      </ts-table>
    </ts-card>
    <!-- upload link -->
    <a-modal
      v-if="show_input_link"
      v-model="show_input_link"
      :title="$t('update')"
      centered
      :zIndex="1020"
      :mask-closable="false"
      width="400px"
      :cancelText="$t('cancel')"
      :okText="$t('save')"
      :confirmLoading="waiting"
      @cancel="onClose"
      @ok="onUpldateLink"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required ts-text-xs">{{ $t('gameConfirmResult.link') }}</label>
            <input type="text" class="form-control" v-model="model.live_url" />
            <div
              class="validate ts-text-xs"
              v-if="errors.has('live_url')"
            >{{ errors.first('live_url') }}</div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import ConfirmPassword from './components/confirm_pwd'
import moment from 'moment'

export default {
  name: 'gameConfirmResult',
  components: {
    ConfirmPassword
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      visible: false,
      show_form_confirm: false,
      show_input_link: false,
      model: {
        result_id: null,
        live_url: null
      },
      confirm: {
        password: null,
        result_date: null,
        game_set_id: null,
        result_number: null,
        is_released: true
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/gameConfirmResult', ['resources']),
    dateFilter: {
      get() {
        return this.$store.state.administrator.gameConfirmResult.date_filter
      },
      set(newValue) {
        this.$store.commit(
          'administrator/gameConfirmResult/SET_FILTER_DATE',
          newValue
        )
      }
    },
    is_release: () => release => {
      return release ? release : false
    },
    columns() {
      return [
        { name: this.$t('gameConfirmResult.gameSet') },
        { name: this.$t('gameConfirmResult.drawTime') },
        { name: this.$t('gameConfirmResult.inputCounter') },
        { name: this.$t('gameConfirmResult.resultNumber') },
        {
          name: this.$t('gameConfirmResult.release'),
          style: 'text-align:center; width:20px'
        },
        { name: this.$t('actions'), style: 'text-align:right; width:10px' }
      ]
    }
  },
  methods: {
    ...mapActions('administrator/gameConfirmResult', ['store']),
    onClose() {
      this.show_input_link = false
      ;(this.model.result_id = null), (this.model.live_url = null)
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/gameConfirmResult/fetch', { ...attributes })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addLink(record) {
      this.model.result_id = record.result_id
      this.model.live_url = record.live_url
        ? 'https://www.youtube.com/watch?v=' + record.live_url
        : null
      this.show_input_link = true
    },
    onUpldateLink() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('administrator/gameConfirmResult/update', {
          id: this.model.result_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.show_input_link = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    confirmResult(record) {
      this.confirm.result_date = moment().format('DD-MM-YYYY')
      this.confirm.game_set_id = record.game_set_id
      this.confirm.result_number = record.result_number
      this.$confirm({
        title: this.$t('gameConfirmResult.do_you_want_to_release'),
        content: h =>
          h(ConfirmPassword, {
            props: {
              value: this.confirm,
              validate: this.errors,
              placeholder: this.$t('gameConfirmResult.password')
            }
          }),
        okText: this.$t('yes'),
        cancelText: this.$t('no'),
        zIndex: 1025,
        centered: true,
        onOk: () => {
          return this.store(this.confirm)
            .then(response => {
              this.$toasted.success(response.message)
              this.clearInput()
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel: () => {
          this.clearInput()
        }
      })
    },
    clearInput() {
      this.confirm.password = null
      this.confirm.result_date = null
      this.confirm.game_set_id = null
      this.confirm.result_number = null
      this.confirm.is_released = true
    },
    onDateChange() {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameConfirmResult/RESET_STATE')
    next()
  }
}
</script>
